document.addEventListener("DOMContentLoaded", function () {
  const setSlideShow = () => {
    const sliders = document.querySelectorAll(".component-hub-slideshow");
    Array.from(sliders).forEach((slider) => {
      new Swiper(slider, {
        direction: "horizontal",
        slidesPerView: 4,
        spaceBetween: 10,
        simulateTouch: true,
        allowTouchMove: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
        // Navigation arrows
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
      });
    });
  };

  setSlideShow();
});
